/* This file is in core bundle because it is used by Parent Guide */

const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const eases = require("eases");
const colors = require("../util/ColorUtil").getCurrentScheme();
const TempCanvas = require("../util/TempCanvas");
const CanvasUtil = require("../util/CanvasUtil");
const AnimatingCanvas = require("./AnimatingCanvas");
const MeasuredEl = require("./MeasuredEl");
const DrawingUtil = require("../util/DrawingUtil");
const {getBaseInstance} = require("../util/HOCUtil");

const styles = require("./styles/StarProgressStandard.css");

module.exports = createReactClass({
	displayName: "StarProgressStandard",

	propTypes: {
		className: PT.string,
		resultID: PT.number,
		styleType: PT.string,
		totalAmount: PT.number,
		filledAmount: PT.number,
		//Includes cutoffs that may be missing right now due to limited maxStars.
		allCutoffs: PT.arrayOf(PT.number),
		starCutoffs: PT.arrayOf(PT.number),
		keepStarsReached: PT.bool,
	},

	getInitialState: function() {
		return {
			starsReached: this.getStars(this.props.filledAmount),
		};
	},

	getBarArea: function(context) {
		//Set area that bar is going to take up inside the context
		const paddingRatio = 0.06;
		return {
			x: context.getWidth() * paddingRatio,
			y: context.getHeight() * 1.8 * paddingRatio,
			w: context.getWidth() - context.getWidth() * 2.2 * paddingRatio,
			h: context.getHeight() * 0.33,
		};
	},

	getStars: function(filledAmount, newStarCutoffs) {
		// when switching between blocks directly, need to make sure we're
		// calculating the initial star count using the incoming starCutoffs
		const cutoffs = newStarCutoffs || this.props.starCutoffs;
		return cutoffs.filter(c => filledAmount >= c).length;
	},

	UNSAFE_componentWillMount: function() {
		this.filled = this.props.filledAmount;
		this.hitStar = this.getStars(this.filled);
		this.squish = 0;
		this.jump = 0;
		this.isAnimating = false;
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		if (nextProps.resultID !== this.props.resultID) {
			this.canvasComp && this.canvasComp.stopAnimations();
			this.redraw = true;
			this.filled = nextProps.filledAmount;
			this.oldFilled = nextProps.filledAmount;
			this.hitStar = this.getStars(this.filled, nextProps.starCutoffs);
		} else {
			this.redraw = false;
		}
	},

	componentDidUpdate: function() {
		this.checkForAnimation();
	},

	makeClipPath: function(context, rects, gapSize) {
		context.beginPath();
		rects.forEach((r, i) => {
			const {x, y, w, h} = r;
			let p1, p2, p3, p4;
			if (i === 0) {
				p1 = {x, y: y + h};
				p2 = {x: x + Math.floor(gapSize), y};
				p3 = {x: x + w - Math.floor(gapSize / 2), y};
				p4 = {x: x + w - Math.floor(gapSize / 2), y: y + h};
			} else if (i === rects.length - 1) {
				p1 = {x: x + Math.floor(gapSize / 2), y: y + h};
				p2 = {x: x + Math.floor(gapSize / 2), y};
				p3 = {x: x + w - gapSize * 1.8, y};
				p4 = {x: x + w, y: y + h};
			} else {
				p1 = {x: x + Math.floor(gapSize / 2), y: y + h};
				p2 = {x: x + Math.floor(gapSize / 2), y};
				p3 = {x: x + w - Math.floor(gapSize / 2), y};
				p4 = {x: x + w - Math.floor(gapSize / 2), y: y + h};
			}
			context
				.M(p1.x, p1.y)
				.L(p2.x, p2.y)
				.L(p3.x, p3.y)
				.L(p4.x, p4.y);
		});
		context.closePath();
	},

	drawBar: function(context) {
		const {x, y, w, h} = this.getBarArea(context);
		const gapSize = h / 3.5;

		//Get star cutoff locations relative to bar size
		const allCutoffs = _.reverse(_.clone(this.props.allCutoffs));
		if (this.props.allCutoffs[0] !== this.props.totalAmount) {
			allCutoffs.push(this.props.totalAmount);
		}
		const cuts = allCutoffs.map(co => (co / this.props.totalAmount) * w);

		//Create temporary canvas to draw the star progress bar
		const tempCanvas = TempCanvas.requestCanvas(w, h);
		CanvasUtil.setCanvasDPI(tempCanvas);
		const tempCtx = CanvasUtil.getShortvas(tempCanvas);

		let startX = 0;
		const rects = cuts.map(c => {
			const retVal = {
				x: startX,
				y: 0,
				w: c - startX,
				h,
			};
			startX = c;
			return retVal;
		});
		tempCtx.clearRect(-1, -1, w + 2, h + 2);
		this.makeClipPath(tempCtx, rects, gapSize);
		tempCtx.stroke(colors.starBarShadow);
		tempCtx.clip();

		//Draw thicker shadow/edge
		tempCtx.lineWidth = h / 8;
		const p1 = {x: 0, y: h};
		const p2 = {x: Math.floor(gapSize), y: 0};
		const p3 = {x: w - gapSize * 1.8, y: 0};
		const p4 = {x: w, y: h};
		tempCtx
			.bp()
			.M(p1.x, p1.y)
			.L(p2.x, p2.y)
			.L(p3.x, p3.y)
			.L(p4.x, p4.y)
			.stroke(colors.starBarShadow);
		tempCtx.lineWidth = h / 12;
		tempCtx
			.bp()
			.M(p1.x, p1.y)
			.L(p4.x, p4.y)
			.stroke(colors.starBarHighlight);

		// Draw yellow progress on top of the progress bar only where it overlaps bar
		tempCtx.save();
		tempCtx.globalCompositeOperation = "destination-over";
		this.drawProgress(tempCtx, {x: 0, y: 0, w, h});
		tempCtx.restore();

		context.drawImage(tempCanvas, x, y);
		TempCanvas.releaseCanvas(tempCanvas);

		//Draw the stars
		this.drawStars(context, x, y, w, h);
	},

	drawProgress: function(context, rect) {
		const width = Math.floor((this.filled / this.props.totalAmount) * rect.w);
		context
			.bp()
			.rect(rect.x, rect.y, width, rect.h)
			.Z()
			.fill(colors.starProgressFill);
		context
			.bp()
			.rect(rect.x + width, rect.y, rect.w - width, rect.h)
			.Z()
			.fill(colors.starBarMain);
	},

	drawStars: function(context, x, y, w, h) {
		//Get star cutoff locations relative to bar size
		const starCutoffs = _.reverse(_.clone(this.props.starCutoffs));
		const cuts = starCutoffs.map(co => (co / this.props.totalAmount) * w);
		const starH = h * 1.2;
		const starW = (starH * 4) / 5;
		const starPadding = h * 1.2;
		const stars = this.props.keepStarsReached
			? Math.max(this.hitStar, this.state.starsReached)
			: this.hitStar;

		cuts.forEach((c, i) => {
			const earned = stars >= 0 && stars > i;
			const o = (starH / 4) * this.squish; //offset for squishing
			const jump = starH * this.jump;
			if (this.squish && stars === i + 1) {
				//Draw distortion of star during animation
				DrawingUtil.drawInsetIcon(
					context,
					"s",
					earned,
					x + c - starW / 2 - o,
					y + starPadding + o - jump,
					starW + o * 2,
					starH - o,
					{insetSize: "small"}
				);
			} else {
				DrawingUtil.drawInsetIcon(
					context,
					"s",
					earned,
					x + c - starW / 2,
					y + starPadding,
					starW,
					starH,
					{insetSize: "small"}
				);
			}
		});
	},

	draw: function(context, options) {
		const fullRedraw = options.resized || options.loadedImages || this.redraw;
		if (fullRedraw) {
			this.oldFilled = this.props.filledAmount;
			this.filled = this.props.filledAmount;
			context.clearRect(
				-1,
				-1,
				context.getWidth() + 2,
				context.getHeight() + 2
			);
			DrawingUtil.drawTopBarYellow(
				context,
				0,
				0,
				context.getWidth(),
				context.getHeight()
			);
			this.drawBar(context);
		}
	},

	animateFilled: function(context, oldFilled, newFilled, t) {
		this.filled = oldFilled + eases.quadIn(t) * (newFilled - oldFilled);
		//Need to clear canvas or else we get jagged edges during and after animation.
		context.clearRect(-1, -1, context.getWidth() + 2, context.getHeight() + 2);
		DrawingUtil.drawTopBarYellow(
			context,
			0,
			0,
			context.getWidth(),
			context.getHeight()
		);
		this.drawBar(context);
	},

	animateStar: function(context, t) {
		this.squish = 0;
		this.jump = 0;
		if (t < 0.4 || (t > 0.4 && t < 0.8)) {
			const ts = t < 0.4 ? t / 0.4 : (t - 0.4) / 0.4;
			this.squish =
				eases.sineInOut(ts) < 0.5
					? eases.sineInOut(ts)
					: 1 - eases.sineInOut(ts);
		}
		if (t > 0.3) {
			// this.jump = t < 0.6 ? eases.quadOut(t) : 1 - eases.backOut(t);
			const tj = (t - 0.3) / 0.7;
			this.jump =
				eases.backOut(tj) < 0.5
					? eases.backOut(tj)
					: Math.abs(1 - eases.backOut(tj));
		}
		//Need to clear canvas or else we get jagged edges during and after animation.
		context.clearRect(-1, -1, context.getWidth() + 2, context.getHeight() + 2);
		DrawingUtil.drawTopBarYellow(
			context,
			0,
			0,
			context.getWidth(),
			context.getHeight()
		);
		this.drawBar(context);
	},

	checkForAnimation: function() {
		if (this.isAnimating) {
			return;
		}

		this.oldFilled = this.oldFilled || 0;
		let animationInfo = false;
		this.hitStar = this.getStars(this.props.filledAmount);
		//When there's a change in filled amount, set animation
		if (this.oldFilled !== this.props.filledAmount) {
			animationInfo = {
				draw: (innerContext, t) =>
					this.animateFilled(
						innerContext,
						this.oldFilled,
						this.props.filledAmount,
						t
					),
				duration: 600,
			};
		} else if (this.hitStar > this.state.starsReached) {
			animationInfo = {
				draw: (innerContext, t) => this.animateStar(innerContext, t),
				duration: 1000,
			};
		}
		//If we need to animate, animate and set up onFinish function
		if (this.canvasComp && animationInfo) {
			const finalFilled = this.props.filledAmount;
			const onFinish = () => {
				this.oldFilled = finalFilled;
				this.squish = 0;
				this.jump = 0;
				this.isAnimating = false;
				this.checkForAnimation();
				if (
					(this.hitStar < this.state.starsReached &&
						!this.props.keepStarsReached) ||
					this.hitStar > this.state.starsReached
				) {
					this.setState({starsReached: this.hitStar});
				}
			};
			this.isAnimating = true;
			this.canvasComp.animateDraw({
				draw: animationInfo.draw,
				duration: animationInfo.duration || 400,
				onFinish,
			});
		}
	},

	render: function() {
		const mainClass = this.props.className || styles.starProgress;
		return (
			<MeasuredEl className={mainClass}>
				<AnimatingCanvas
					noPointerEvents={true}
					draw={this.draw}
					ref={ref => (this.canvasComp = getBaseInstance(ref))}
				/>
			</MeasuredEl>
		);
	},
});
